import { parseISO, startOfDay } from 'date-fns';
import type { SelfServiceAPI } from 'types';

const getBlockedDates = (stays: SelfServiceAPI.Stay[]) =>
  stays.reduce((blocked: Date[], stay: SelfServiceAPI.Stay) => {
    if (!stay.available) {
      blocked.push(startOfDay(parseISO(stay.checkIn)));
    }

    return blocked;
  }, []);

export default getBlockedDates;
